// extracted by mini-css-extract-plugin
export default {"profile-btn":"styles_profile-btn__6cI3W"};